import React, { useState, useRef, useEffect } from "react";
import theme from "../../../styles/theme";

const LoaderDropdown = ({
  label = "Sélectionner",
  options = [],
  onSelect,
  disabled = false,
  size = "md",
  placeholder = "Aucune option",
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const toggleOpen = () => {
    if (!disabled) setOpen((prev) => !prev);
  };

  const handleSelect = (option) => {
    onSelect && onSelect(option);
    setOpen(false);
  };

  // Ferme le menu si clic à l’extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const sizes = {
    sm: { padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`, fontSize: theme.fontSizes.sm },
    md: { padding: `${theme.spacing.sm}px ${theme.spacing.md}px`, fontSize: theme.fontSizes.md },
  };

  return (
    <div ref={ref} style={{ position: "relative", width: "220px" }}>
      {/* Bouton principal */}
      <button
        onClick={toggleOpen}
        disabled={disabled}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: sizes[size].padding,
          fontSize: sizes[size].fontSize,
          fontFamily: theme.fonts.primary,
          color: disabled ? theme.colors.text.disabled : theme.colors.text.default,
          backgroundColor: disabled
            ? theme.buttons.disabled.background
            : theme.colors.background.input,
          border: `1px solid ${theme.colors.borders.default}`,
          borderRadius: theme.borders.radius.sm,
          cursor: disabled ? "not-allowed" : "pointer",
          transition: "background-color 0.2s",
        }}
      >
        <span>{label}</span>
        <span
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}
        >
          ▼
        </span>
      </button>

      {/* Liste déroulante */}
      {open && !disabled && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            width: "100%",
            marginTop: theme.spacing.xs,
            backgroundColor: theme.colors.background.surface,
            border: `1px solid ${theme.colors.borders.default}`,
            borderRadius: theme.borders.radius.sm,
            boxShadow: theme.shadows.md,
            zIndex: 20,
            maxHeight: "180px",
            overflowY: "auto",
          }}
        >
          {options.length > 0 ? (
            options.map((opt) => (
              <div
                key={opt.value}
                onClick={() => handleSelect(opt)}
                style={{
                  padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
                  cursor: "pointer",
                  backgroundColor: theme.colors.background.surface,
                  color: theme.colors.text.default,
                  transition: "background-color 0.2s",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = theme.colors.background.muted)}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = theme.colors.background.surface)}
              >
                {opt.label}
              </div>
            ))
          ) : (
            <div
              style={{
                padding: `${theme.spacing.sm}px ${theme.spacing.md}px`,
                color: theme.colors.text.secondary,
                fontStyle: "italic",
              }}
            >
              {placeholder}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LoaderDropdown;
